module.exports = __webpack_public_path__ + "static/elrow-MONEI-28d87f37a00129f025c8818fcb4ecc59.png";